import type { VisibilityColumn } from "@amber/ui";
import type { ItemStatus, StatusGroup } from "../../contracts/index";

export const GROUPS: readonly { key: StatusGroup; label: string; note: string; statuses: readonly ItemStatus[] }[] = [
  { key: "active", label: "Active", note: "New and running, newest first", statuses: ["new", "in_progress"] },
  {
    key: "needs_attention",
    label: "Needs attention",
    note: "Failed first, then waiting · newest first",
    statuses: ["failed", "waiting"],
  },
  { key: "finished", label: "Finished", note: "Newest first", statuses: ["finished"] },
  { key: "excluded", label: "Excluded", note: "Kept for reference", statuses: ["excluded"] },
];

export const GROUP_OF: Record<ItemStatus, StatusGroup> = {
  new: "active",
  in_progress: "active",
  failed: "needs_attention",
  waiting: "needs_attention",
  finished: "finished",
  excluded: "excluded",
};

export const COLUMNS = [
  { id: "people", label: "Person(s)", width: 136, narrow: false, default: true },
  { id: "platform", label: "Platform", width: 112, narrow: false, default: true, sort: "platform" },
  { id: "channel", label: "Channel / programme", width: 170, narrow: false, default: true, sort: "channel" },
  { id: "progress", label: "Progress", width: 176, narrow: true, default: true },
  { id: "stage", label: "Stage", width: 176, narrow: false, default: true },
  { id: "status", label: "Status", width: 132, narrow: true, default: true, sort: "status" },
  { id: "readiness", label: "Readiness", width: 110, narrow: true, default: true },
  { id: "type", label: "Type", width: 70, narrow: false, default: true, sort: "type" },
  { id: "duration", label: "Duration / size", width: 140, narrow: false, default: true },
  { id: "language", label: "Lang.", width: 60, narrow: false, default: false },
  { id: "published", label: "Published", width: 100, narrow: false, default: true, sort: "published" },
  { id: "discovered", label: "Discovered", width: 100, narrow: false, default: true, sort: "discovered" },
] as const;

export type ColumnId = (typeof COLUMNS)[number]["id"];
export type Column = (typeof COLUMNS)[number];

export const BACKLOG_VISIBILITY: readonly VisibilityColumn[] = [
  { id: "title", label: "Title", canHide: false },
  ...COLUMNS.map((c) => ({ id: c.id, label: c.label, hiddenByDefault: !c.default })),
];
